import { module } from 'modujs';
import Drift from 'drift-zoom';

export default class extends module {
    constructor(m) {
        super(m);
        this.image = document.querySelector('.productImage');
        this.panel = this.image.parentElement;

        new Drift(this.image, {
            paneContainer: this.panel,
            inlinePane: false,
        });

    }
}
